import Vladimir from "../assets/images/Vladimir.png";
function About() {
  return (
    <section id="About" className="sb-about">
      <div className="sb-about-inner">

        <div className="sb-about-portrait">
          <img
            src={Vladimir}
            alt="Vladimir Lamérique"
          />
          <h2 className="sb-about-name">Vladimir Lamérique</h2>
        </div>

        <div className="sb-about-content">
          <p className="sb-about-label">About</p>
          <h3 className="sb-about-heading">Expert bookkeeping,<br />built around your business.</h3>
          <p className="sb-about-body">
            At SweptBooks, we believe that a well-organized financial record is the foundation of a successful business. Our mission is to help you uncover insights, boost profits, and drive smarter decisions by sweeping away financial clutter, bringing clarity and order to your books. With our expert bookkeeping services, you can focus on what you do best – growing your business – while we handle the numbers.
          </p>
          
            <a className="sb-about-cta"
            href="https://calendly.com/contact-sweptbooks/30min"
            target="_blank"
            rel="noreferrer"
          >
            Work with me
          </a>
        </div>

      </div>
    </section>
  );
}

export default About;